export const filterOptions = (isClientOperator: boolean) => [
  {
    key: 'instance_id',
    label: 'DYNAMIC_FILTER.INSTANCE_ID_KEY',
    hidden: isClientOperator,
  },
  {
    key: 'flavor',
    label: 'DYNAMIC_FILTER.FLAVOR_KEY',
    hidden: isClientOperator,
  },
  { key: 'name', label: 'DYNAMIC_FILTER.NAME_KEY' },
];
